import React, { useState } from "react";
import "./IconicFAQ.css";
import OurCompanies from "../Home/OurCompanies";
import CommonBannar from "./CommonBannar";

const IconicFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  const faqData = [
    {
      id: 1,
      question: "What is Iconic Greenland?",
      answer:
        "Iconic Greenland Ltd. is the real estate concern of Iconic Unity Group. It focuses on building planned, sustainable residential communities with modern design, quality construction, and long-term livability.",
      category: "general",
    },
    {
      id: 2,
      question: "What is Iconic City?",
      answer:
        "Iconic City is a flagship residential development project by Iconic Greenland. It aims to create a modern, well-planned community with quality apartments, thoughtful infrastructure, and a focus on sustainable living.",
      category: "real-estate",
    },
    {
      id: 3,
      question: "Who is the construction partner of Iconic City?",
      answer:
        "Iconic City is being developed in partnership with Our Builder Ltd. The collaboration was formalized through a signing ceremony on 12 March 2025 to ensure quality construction and timely project delivery.",
      category: "real-estate",
    },
    {
      id: 4,
      question: "Has the foundation stone of Iconic City been laid?",
      answer:
        "Yes. The foundation stone ceremony has already been completed with prayers and the symbolic placement of the first bricks, marking the official start of construction.",
      category: "real-estate",
    },
    {
      id: 5,
      question: "What is the current progress of Iconic City?",
      answer:
        "Construction is actively underway. Foundation work, rebar binding, brickwork, and site preparation are in progress. Billboards for City Tower are also visible around the project area.",
      category: "real-estate",
    },
    {
      id: 6,
      question: "Does Iconic Greenland engage with the local community?",
      answer:
        "Yes. Iconic Greenland organizes community gatherings, discussion programs, and shared events to keep local residents informed and involved throughout the development process.",
      category: "real-estate",
    },
    {
      id: 7,
      question: "What type of residential units will Iconic City offer?",
      answer:
        "Iconic City is planned as a modern residential development with well-designed apartments focused on comfort, functionality, and long-term value for homeowners and investors.",
      category: "real-estate",
    },
    {
      id: 8,
      question: "Is Iconic City focused on sustainable development?",
      answer:
        "Yes. Iconic Greenland approaches real estate as long-term community building, balancing modern design, practical infrastructure, green considerations, and future-ready planning.",
      category: "real-estate",
    },
    {
      id: 9,
      question: "How can I get updates about Iconic City?",
      answer:
        "You can stay updated through the official Iconic Unity Group website, contact the Iconic Greenland team directly, or follow project progress announcements and community events.",
      category: "general",
    },
    {
      id: 10,
      question: "How can I contact Iconic Greenland for inquiries?",
      answer:
        "You can reach Iconic Greenland through the official contact page of Iconic Unity Group or by contacting the corporate office for project-related and sales inquiries.",
      category: "general",
    },
  ];

  const toggleFAQ = (id) => {
    setActiveIndex(activeIndex === id ? null : id);
  };

  const filteredFAQs = faqData.filter((item) => {
    const matchesSearch = item.question
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === "all" || item.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // Split into 5 and 5
  const half = Math.ceil(filteredFAQs.length / 2);
  const leftCol = filteredFAQs.slice(0, half);
  const rightCol = filteredFAQs.slice(half);

  return (
    <div className="faq-page-master">
      {/* 1. Full Width Banner */}
      <CommonBannar
        title={"HOW CAN WE HELP YOU?"}
        des={"Search for answers or browse the topics below"}
      ></CommonBannar>

      {/* 2. Centered Content (1440px) */}
      <div className="faq-content-wrapper">
        <div className="faq-container-1440">
          {/* 5+5 Grid Layout */}
          {filteredFAQs.length > 0 ? (
            <div className="faq-grid-container">
              <div className="faq-column">
                {leftCol.map((item) => (
                  <div
                    key={item.id}
                    className={`faq-card ${activeIndex === item.id ? "active" : ""}`}
                    onClick={() => toggleFAQ(item.id)}
                  >
                    <div className="faq-card-question">
                      <span>{item.question}</span>
                      <span className="faq-arrow-icon">▼</span>
                    </div>
                    <div className="faq-card-answer">
                      <div className="faq-answer-content">{item.answer}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="faq-column">
                {rightCol.map((item) => (
                  <div
                    key={item.id}
                    className={`faq-card ${activeIndex === item.id ? "active" : ""}`}
                    onClick={() => toggleFAQ(item.id)}
                  >
                    <div className="faq-card-question">
                      <span>{item.question}</span>
                      <span className="faq-arrow-icon">▼</span>
                    </div>
                    <div className="faq-card-answer">
                      <div className="faq-answer-content">{item.answer}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="faq-no-data">
              No results found for "{searchTerm}"
            </div>
          )}
          {/* White CTA Section */}
        </div>
      </div>
      <OurCompanies></OurCompanies>
    </div>
  );
};

export default IconicFAQ;
